import { InsightRow } from "./InsightsTable";

export const compareDesc = (a: number, b: number): number => {
    if (a === b) return 0;
    return b > a ? 1 : -1;
};

export const compareAsc = (a: number, b: number): number => {
    if (a === b) return 0;
    return a > b ? 1 : -1;
};

export const compareDisabledExposures = (a: InsightRow, b: InsightRow, showEmptyAndHiddenExposures: boolean): number | null => {
    if (!showEmptyAndHiddenExposures) return null;
    
    if (a.isHidden && b.isHidden) {
        return compareDesc(a.severity, b.severity);
    }
    
    if (a.isHidden && !b.isHidden) return 1;
    if (!a.isHidden && b.isHidden) return -1;
    
    return null;
};